import React, { memo } from 'react';
import * as PropTypes from 'prop-types';
import useUiContext from '@groupefungo/react-apollo.core/ui/UseContext';
import { dressTypeOptions } from '../../booking-system/appointment-booking/src/components/appointments/dressTypeOptions';

const DressTypeSelect = ({ label, name, value, error, onChange }) => {
  const { SelectMui } = useUiContext();

  return (
    <SelectMui
      id="dress_type_select"
      label={label}
      name={name}
      value={value}
      onChange={onChange}
      options={dressTypeOptions}
      error={error}
      MenuProps={{
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'left',
        },
        getContentAnchorEl: null,
        // classes: { paper: menuClasses.menuPaper },
      }}
    />
  );
};

DressTypeSelect.defaultProps = {
  label: 'Dress Type',
  disabled: false,
  name: 'dressType',
  error: false,
};
DressTypeSelect.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  error: PropTypes.bool,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default memo(DressTypeSelect);
